export default __webpack_public_path__ + "images/1f07e1d27429a9b36b4f2aa9ed46f856-folk.jpg";